// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bim-compare__viewer .v-overlay__content{align-items:center;display:flex;justify-content:center;position:absolute}.bim-compare__viewer .v-slider__thumb{border-radius:0!important;cursor:ew-resize;height:100vh!important;left:-24px;width:40px}.bim-compare__viewer .v-input__slider{position:absolute;top:50%;width:100%;z-index:4}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
